import { render, staticRenderFns } from "./MusicAudio.vue?vue&type=template&id=e52b7ffe&"
import script from "./MusicAudio.vue?vue&type=script&lang=js&"
export * from "./MusicAudio.vue?vue&type=script&lang=js&"
import style0 from "./MusicAudio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports